module.exports = __webpack_public_path__ + "static/media/Key.2bde5d49.svg";